import { useCallback } from "react";
import { useMutation, useQueryClient } from "react-query";
import { Api } from "src/apis/helpers/configs/api";
import { ProjectsService } from "src/apis/services/projects/projectsService";
import { ProjectsDto } from "src/data/models/projectsDtos/projectsDto.interface";
import { container } from "tsyringe";

export const useEditProjects = () => {
    const projectsService = container.resolve(ProjectsService);
    const queryClient = useQueryClient();
    const toggleEditUser = useCallback(
        (data, variables, context) => {
            let tempData = queryClient.getQueryData<Array<ProjectsDto>>([Api.Projects.getProjects]);
            const newData = [...tempData] ;
            const findIndex = newData.findIndex(x=>x.projectId === data.projectId) ;
            newData[findIndex] = data;
            tempData = newData;
            queryClient.setQueryData([Api.Projects.getProjects],tempData )
        },
        [],
    );
    return useMutation({
        mutationFn: (data: ProjectsDto) => {
            return projectsService.editProjects(data);
        },
        onSuccess: toggleEditUser
    })

}
